import gql from 'graphql-tag';
export const CREATE_PORTAL_SESSION = gql`
    mutation createPortalSession($session_id: ID!){
        createPortalSession(session_id: $session_id)
    }
`;